const WhoWeAre = () => {
  return (
    <div className="who-we-are-container">
      <div className="who-we-are-innercontainer">
        <div className="who-we-are-title">
          <span className="red">Who</span> Are We?
        </div>
        <p className="who-we-are-desc">
          LovenCoders is a passionate team of startup mentors, tech experts, and
          innovators dedicated to helping entrepreneurs transform their ideas
          into impactful businesses.
        </p>
        <p className="who-we-are-desc">
          We understand the challenges of entrepreneurship because we've been
          there ourselves – from brainstorming ideas to scaling companies. We’re
          on a mission to simplify the entrepreneurial journey and empower
          startups with the tools, guidance, and community they need to thrive. 
        </p>
      </div>
    </div>
  );
};

export default WhoWeAre;
